import { render, staticRenderFns } from "./DocumentationContent.vue?vue&type=template&id=f4c24dd6&style=position%3A%20sticky"
import script from "./DocumentationContent.vue?vue&type=script&lang=js"
export * from "./DocumentationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports